import _ from 'lodash'
import utils from '@/utils'
let resizeHandler
export default {
  data () {
    return {
      chart: undefined
    }
  },
  mounted () {
    resizeHandler = _.debounce(() => {
      this.handleResize()
    }, 300)
    utils.EventBinder.bind(window, 'resize', resizeHandler)
  },
  beforeDestroy () {
    utils.EventBinder.unbind(window, 'resize', resizeHandler)
  },
  methods: {
    handleResize () {
      this.chart && typeof this.chart.resize === 'function' && this.chart.resize()
    }
  }
}
